export const eventWays = [
    {
        id: 1,
        icon: ``,
        title: "اجتماع لمرة واحدة",
        content: "إتاحة موعد استثنائي لاجتماع واحد خارج جدولك المعتاد.",
    },
    {
        id: 2,
        icon: ``,
        title: "تصويت لاختيار الموعد",
        content:
            "دع المدعوين يختارون الموعد الأنسب بسهولة، دون مراسلات متكررة.",
    },
];


// Event ways for sales page - can be customized later
export const eventWaysSales = [
    {
        id: 1,
        icon: ``,
        title: "اجتماع لمرة واحدة",
        content: "إتاحة موعد استثنائي لاجتماع واحد خارج جدولك المعتاد.",
    },
    {
        id: 2,
        icon: ``,
        title: "تصويت لاختيار الموعد",
        content:
            "دع المدعوين يختارون الموعد الأنسب بسهولة، دون مراسلات متكررة.",
    },
];

// Event ways for marketing page - can be customized later
export const eventWaysMarketing = [
    {
        id: 1,
        icon: ``,
        title: "اجتماع لمرة واحدة",
        content: "إتاحة موعد استثنائي لاجتماع واحد خارج جدولك المعتاد.",
    },
    {
        id: 2,
        icon: ``,
        title: "تصويت لاختيار الموعد",
        content:
            "دع المدعوين يختارون الموعد الأنسب بسهولة، دون مراسلات متكررة.",
    },
];

// Event ways for recruiting page - can be customized later
export const eventWaysRecruiting = [
    {
        id: 1,
        icon: ``,
        title: "رابط حجز لكل لمرشح",
        content: "أنشئ رابط حجز خاص يُستخدم مرة واحدة فقط، للتحكم الكامل في من يحجز الموعد.",
    },
    {
        id: 2,
        icon: ``,
        title:"تصويت لاختيار الموعد",
        content:
           "نسّق مقابلات لجان التوظيف بدون صداع. أرسل تصويتًا داخليًا لأعضاء اللجنة لاختيار الوقت المناسب للجميع.",
    },
];

// Event ways for customer-success page - can be customized later
export const eventWaysCustomerSuccess = [
    {
        id: 1,
        icon: ``,
        title: "اجتماع لمرة واحدة",
        content: "إتاحة موعد استثنائي لاجتماع واحد خارج جدولك المعتاد.",
    },
    {
        id: 2,
        icon: ``,
        title: "تصويت لاختيار الموعد",
        content:
            "دع المدعوين يختارون الموعد الأنسب بسهولة، دون مراسلات متكررة.",
    },
];

// Event ways for services page - can be customized later
export const eventWaysServices = [
    {
        id: 1,
        icon: ``,
        title: "اجتماع لمرة واحدة",
        content: "إتاحة موعد استثنائي لاجتماع واحد خارج جدولك المعتاد.",
    },
    {
        id: 2,
        icon: ``,
        title: "تصويت لاختيار الموعد",
        content:
            "دع المدعوين يختارون الموعد الأنسب بسهولة، دون مراسلات متكررة.",
    },
];
